<template>
  <div id="serviceAskingPage">
    <ServiceAsking></ServiceAsking>
  </div>
</template>
<script>
import ServiceAsking from '@/components/customerService/ServiceAsking.vue'

export default {
  name: 'serviceAskingPage',
  components: {
    ServiceAsking,
  },
  data: function() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
#serviceAskingPage {
  display: flex;
  flex-flow: column;
  margin-bottom: -78px;
}
</style>
